import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ProgressBar from '../components/ProgressBar';
import SensitiveImage from '../images/Sensitiveskin.png';
import IdkImage from '../images/dontknow.png';
import NotSensitiveImage from '../images/not-Sensitiveskin.png';
import Popup from './Popup';
import './SkinSensitivity.css';

const SkinSensitivity = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedSensitivity, setSelectedSensitivity] = useState({});
    const [currentStep] = useState(3);
    const [showSkipPopup, setShowSkipPopup] = useState(false);
    const [skinSensitivityList, setSkinSensitivityList] = useState([]);
    const fromProfile = location.state?.fromProfile;

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            sessionStorage.clear();
            setSelectedSensitivity({});
        } else {
            getSkinSensitivityOptions();
            const storedSensitivity = JSON.parse(sessionStorage.getItem('skin-sensitivity')) || {};
            setSelectedSensitivity(storedSensitivity);
        }
    }, []);
// Handler for selecting a skin sensitivity option
    const handleSelectSensitivity = (sId, sName) => {
        const sensitivity = { id: sId, name: sName };
        setSelectedSensitivity(sensitivity);

        // Store in sessionStorage only if the selected sensitivity is not "I'm not sure"
        if (sName !== "I'm not sure") {
            sessionStorage.setItem('skin-sensitivity', JSON.stringify(sensitivity));
        } else {
            getQAFormQuestions(); // Call the function to navigate to the questions if "I'm not sure" is selected
        }
    };

    // Navigate to the next page
    const handleNextClick = async () => {
        navigate("/select-skintone");
    };

    // Navigate back to the previous page
    const handleBackClick= async () => {
        navigate("/skin-concerns");
    };

    // Show skip confirmation popup
    const handleSkipClick = () => {
        setShowSkipPopup(true);
    };
// Confirm skip action and navigate to the next page
    const handleSkipConfirm = () => {
        setShowSkipPopup(false);
        navigate('/select-skintone');
    };
    // Handle the update of the selected skin sensitivity in the profile
    const handleUpdateSensitivityClick = async () => {
        const storedSkinSensitivity = sessionStorage.getItem('skin-sensitivity');

        // Function to extract the ID from stored sensitivity
        const parseAndExtractId = (storedValue) => {
            try {
                const parsedValue = JSON.parse(storedValue);
                return parsedValue?.id || null;
            } catch {
                return null;
            }
        };

        const skinSensitivityId = parseAndExtractId(storedSkinSensitivity);

        const quizData = {
            skin_sensitive_type: skinSensitivityId,
        };

        console.log('Skin quiz data to store in database:', quizData);

        try {
             // Make an API call to update skin sensitivity data
            const response = await fetch('https://dev-api.curu.com.au/api/profile', {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify(quizData)
            });

            if (!response.ok) {
                throw new Error('Failed to save the skin quiz data.');
            }

            // Optionally navigate after successful update
            navigate('/user-profile'); // Change this to your desired route after update
        } catch (error) {
            console.error('Error saving quiz data:', error.message);
            alert('There was a problem saving your quiz data. Please try again.');
        }
    };

    // Fetch question data for the Q&A form based on sensitivity
    const getQAFormQuestions = async () => {
        try {
            let token = localStorage.getItem('token');
            const response = await fetch('https://dev-api.curu.com.au/api/questions?type=3', {
                method: 'GET',
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }
            });

            if (response.ok) {
                const data = await response.json();
                // Navigate to the Q&A form page with the fetched questions
                
                navigate('/find-skin-sensitivity', { state: { questions: data,fromProfile  } });
            } else {
                console.error('Failed to fetch questions');
            }
        } catch (error) {
            console.error(error.message);
        }
    };

    // Fetch skin sensitivity options from the API
    const getSkinSensitivityOptions = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch('https://dev-api.curu.com.au/api/skin-sensitive', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                const errorResponse = await response.json();
                throw new Error(`Failed to get skin sensitivity options: ${errorResponse.message || response.statusText}`);
            }

            const skinSensitivities = await response.json();
            // Map and set skin sensitivity options for rendering
            setSkinSensitivityList(skinSensitivities.map(item => ({
                id: item.id,
                name: item.name,
                description: item.description
            })));
        } catch (error) {
            console.error(error.message);
            throw error;
        }
    };
 // Mapping skin sensitivity names to their respective images
    const mapSkinSensitivityImages = {
        "Sensitive": SensitiveImage,
        "Not Sensitive": NotSensitiveImage,
        "I'm not sure": IdkImage
    };

    const isNextButtonDisabled = !selectedSensitivity.id;

    return (
        <div className="page-containersensitivity">
            <div className="skin-sensitivity-container">
            {!fromProfile && (
                <button className="skip-link-skin-sensitivity" onClick={handleSkipClick}>Skip</button>
            )}
                <ProgressBar currentStep={currentStep} comboType="combo2" />
                <div className="title-container-skin-sensitivity">
    <h1 className="title-skin-sensitivity">Skin Sensitivity</h1>
</div>
                <div className="options-skin-sensitivity">
                    {skinSensitivityList.map((item, index) => (
                        <div
                            key={index}
                            className={`selection-item2 ${selectedSensitivity.id === item.id ? 'selected' : ''}`}
                            onClick={() => handleSelectSensitivity(item.id, item.name)}
                        >
                            <img src={mapSkinSensitivityImages[item.name]} alt={item.name} className="sensitivity-image" />
                            <div className="sensitivity-content">
                                <label htmlFor={`sensitivity-option-${index}`} className="radio-label">
                                    <input
                                        type="radio"
                                        name="skinSensitivity"
                                        checked={selectedSensitivity.name === item.name}
                                        id={`sensitivity-option-${index}`}
                                        className="radio-input"
                                    />
                                    <span className="sensitivity-name">{item.name}</span>
                                </label>
                                <div className="sensitivity-description">{item.description}</div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="buttons-container-skin-sensitivity">
                    {!fromProfile ? (
                        <>
                            <button className="back-button-skin-sensitivity" onClick={
                                // () => navigate('/skin-concerns')
                                handleBackClick
                                }>Back</button>
                            <button
                                className={`next-button-skin-sensitivity ${isNextButtonDisabled ? 'disabled' : ''}`}
                                onClick={handleNextClick}
                                disabled={isNextButtonDisabled}
                            >
                                Next
                            </button>
                        </>
                    ) : (
                        <>
                        <button
  className="close-button-skin-sensitivity"
  onClick={() => navigate('/user-profile')}
>
                         Close
                       </button>
                        <button className="update-button-skin-sensitivity" onClick={handleUpdateSensitivityClick} disabled={isNextButtonDisabled}>
                            Update
                        </button>
                        </>
                    )}
                </div>

                {showSkipPopup && (
                    <Popup
                        isVisible={showSkipPopup}
                        title="Skip Skin Sensitivity"
                        onClose={() => setShowSkipPopup(false)}
                        onConfirm={handleSkipConfirm}
                    />
                )}
            </div>
        </div>
    );
};

export default SkinSensitivity;
